import { WarningCircleIcon } from "@phosphor-icons/react";
import { Component, type PropsWithChildren } from "react";

import { Button } from "../ui/Button";

type AppErrorBoundaryState = { hasError: boolean };

export class AppErrorBoundary extends Component<PropsWithChildren, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  private reload = () => window.location.reload();

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <main className="grid min-h-[100dvh] place-items-center bg-canvas px-5 text-text">
        <section className="w-full max-w-lg rounded-panel border border-danger-border bg-surface-raised p-8 shadow-panel" role="alert">
          <WarningCircleIcon aria-hidden="true" className="size-9 text-danger" weight="duotone" />
          <h1 className="mt-5 text-2xl font-semibold tracking-tight">BurgePOS could not open this view</h1>
          <p className="mt-3 leading-7 text-text-muted">
            Your work may still be saved. Reload the workspace, then contact support if this message returns.
          </p>
          <Button className="mt-7" onClick={this.reload}>Reload workspace</Button>
        </section>
      </main>
    );
  }
}
